// -
import React from "react";
import {reduxForm} from "redux-form";
import {Row, Col} from 'reactstrap';
import {AbstractReactComponent, ff, form} from "mc/lib";

const Form = form.Form;
const FormActions = form.FormActions;
const FormBody = form.FormBody;

import "./ParovaniPlatebForm.scss";

/**
 * Formulář pro filtr plateb pro párování.
 */
class ParovaniPlatebForm extends AbstractReactComponent {

    static formName = 'ParovaniPlatebForm';

    render() {
        const {handleSubmit, submitting, error, anyTouched} = this.props;

        return (
            <Form onSubmit={handleSubmit}>
                <FormBody>
                    {error && anyTouched && <Row>
                        <Col>
                            <h4 className="text-red">{error}</h4>
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={12} sm={6} md={3}>
                            <ff.SimpleDate label="Datum platby od - do" name="datumPlatbyOd" />
                            <ff.SimpleDate label="" name="datumPlatbyDo" />
                        </Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="Číslo účtu" name="cisloUctu" /></Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="IBAN" name="iban" /></Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="SWIFT" name="swift" /></Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6} md={3}><ff.String label="Částka" name="castka" /></Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="Variabilní symbol" name="vs" /></Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="Specifický symbol" name="ss" /></Col>
                        <Col xs={12} sm={6} md={3}><ff.String label="Poznámka" name="poznamka" /></Col>
                    </Row>
                </FormBody>
                <FormActions disabled={submitting} submitButton={"Hledat"} />
            </Form>
        );
    }
}

const reduxFormObj = reduxForm({
    form: ParovaniPlatebForm.formName,
    validate: (data) => {
        return data && Object.values(data).filter(i => !!i).length > 0 ? {} : {"_error": "Nebyla zadána vyhledávací podmínka"};
    },
})(ParovaniPlatebForm);

export default reduxFormObj;
